<script setup lang="ts">
import type { GalleryImage } from '@/types/images'

import ImageBento from './ImageBento.vue'
import ImageCarousel from './ImageCarousel.vue'

interface Props {
  images: GalleryImage[]
}

defineProps<Props>()
</script>

<template>
  <div class="image-gallery">
    <ImageCarousel class="mobile-experience" :images="images" />
    <ImageBento class="desktop-experience" :images="images" />
  </div>
</template>

<style scoped>
.image-gallery {
  width: 100%;
}
</style>
